<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加用户分组"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="userGroupInfo" :rules="rules" >
      <FormItem prop="name">
        <Input v-model="userGroupInfo.name" placeholder="请输入用户分组名称">
        </Input>
      </FormItem>
      <FormItem prop="telephone">
        <Input v-model="userGroupInfo.telephone" placeholder="请输入联系电话">
        </Input>
      </FormItem>
      <FormItem prop="address">
        <Input v-model="userGroupInfo.address" placeholder="请输入联系地址">
        </Input>
      </FormItem>
      <FormItem prop="contactName">
        <Input v-model="userGroupInfo.contactName" placeholder="请输入联系人姓名">
        </Input>
      </FormItem>
      <FormItem prop="contactPhoneNum">
        <Input v-model="userGroupInfo.contactPhoneNum" placeholder="请输入联系人手机">
        </Input>
      </FormItem>
      <FormItem prop="description">
        <Input v-model="userGroupInfo.description" placeholder="请输入描述">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'addusergroupmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      parentUserGroupId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '用户分组名不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        userGroupInfo: {
          name:null,
          telephone:null,
          description:null,
          address:null,
          contactName:null,
          contactPhoneNum:null,
          parentUserGroupId:null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserGroupServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加用户分组',
          content: '<p>是否确认添加用户分组</p>',
          onOk: () => {
            store.dispatch('UserGroupServ_AddObj', {params: this.userGroupInfo}).then(() => {
              this.$Message.success('添加用户分组成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.userGroupInfo.name = null
          this.userGroupInfo.telephone = null
          this.userGroupInfo.description = null
          this.userGroupInfo.address = null
          this.userGroupInfo.contactName = null
          this.userGroupInfo.contactPhoneNum = null
          this.userGroupInfo.parentUserGroupId = this.parentUserGroupId
          console.log(this.userGroupInfo.parentUserGroupId)
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _parentUserGroupId: {
        get() {
          return this.parentUserGroupId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
